var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.488 3.515c-4.685-4.68-12.277-4.678-16.96.005-4.682 4.684-4.682 12.276 0 16.96 4.683 4.683 12.275 4.686 16.96.005 4.678-4.69 4.678-12.28 0-16.97zm-3.779 11.764a1 1 0 0 1-1.409 1.415l-3.11-3.11a.252.252 0 0 0-.354 0l-3.109 3.11c-.395.38-1.02.38-1.415 0a1 1 0 0 1 0-1.415l3.11-3.109a.249.249 0 0 0 0-.353l-3.11-3.11a1 1 0 0 1 1.41-1.415l3.109 3.11a.25.25 0 0 0 .354 0l3.11-3.11a1 1 0 0 1 1.414 1.415l-3.11 3.11a.25.25 0 0 0 0 .353l3.11 3.109z",
    fill: "#FC532E",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.ddb256acc62d5db72d01977af6523da6.svg";
export { ForwardRef as ReactComponent };